import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav-notifications__title-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "nav-notifications__count-dot"
}
const _hoisted_4 = {
  key: 0,
  class: "nav-notifications__wrap-panel"
}

import { ref, computed, watchEffect, PropType } from 'vue'
import { useStore } from '@/store'

import { NotificationStatus, Notification } from '@/types/notification'
import { NavigationPanel } from '@/types/panel'

import NavigationPanelHandlerService from '@/services/NavigationPanelHandlerService'
import WindowEventsService, { CSS_BREAKPOINTS } from '@/services/WindowEventsService'
import MainNotificationPanel from '@feature/main-navigation/MainNotificationPanel.vue'
import AppOverlay from '@common/AppOverlay.vue'

import MobileNotificationsTransition from '@transition/MobileNotificationsTransition.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  minimized: Boolean,
  navigationPanel: {
    type: String as PropType<NavigationPanel>,
    required: true
  }
},
  setup(__props) {

const props = __props



const hasNewNotification = ref(false)
const notificationsPanelActive = computed(() => NavigationPanelHandlerService.isCurrentlyActive(props.navigationPanel))
const isXSBreakpoint = computed(() => WindowEventsService.matches(CSS_BREAKPOINTS.xs))

const toggleNotificationVisibility = async () => {
  if (notificationsPanelActive.value) {
    await hideNotificationPanel(true)
  } else {
    showNotificationPanel()
  }
}

const showNotificationPanel = () => {
  NavigationPanelHandlerService.open(props.navigationPanel)
}

const hideNotificationPanel = async (force: boolean | PointerEvent) => {
  // close only if force attribute sent or it's desktop view
  if ((notificationsPanelActive.value && !isXSBreakpoint.value) ||
    (isXSBreakpoint.value && (typeof (force) === 'boolean'))) {
    NavigationPanelHandlerService.close()
    await store.dispatch('notifications/markAllNotificationsAsRead')
  }
}

const store = useStore()
const notifications = computed<Notification[]>(() => {
  return store.getters['notifications/getNotifications']?.filter((x: Notification) => x.status !== NotificationStatus.Dismissed)
})
const notificationsUnread = computed(() => {
  return notifications.value.filter(x => x.status === NotificationStatus.New)
})

watchEffect(() => {
  if (notificationsUnread.value.length > 0) {
    hasNewNotification.value = true
  }
})

setTimeout(() => {
  hasNewNotification.value = false
}, 2000)

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _directive_test = _resolveDirective("test")!
  const _directive_clicked_outside = _resolveDirective("clicked-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-notifications", [
    _unref(notificationsPanelActive) && 'nav-notifications--panel-visible',
    __props.minimized && 'nav-notifications--minimized'
  ]])
  }, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      class: "nav-notifications__button",
      onClick: toggleNotificationVisibility
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_unref(notificationsUnread).length)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nav-notifications__count", { 'nav-notifications__count--has-new-notification': hasNewNotification.value }])
            }, [
              _createTextVNode(_toDisplayString(_unref(notificationsUnread).length), 1)
            ], 2)), [
              [_directive_test, 'notifications-count']
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AppIcon, { name: "bell" }),
          (!__props.minimized)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Notifications"))
            : _createCommentVNode("", true)
        ]),
        (_unref(notificationsUnread).length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(notificationsUnread).length), 1))
          : _createCommentVNode("", true)
      ])), [
        [_directive_test, 'open-notification-panel']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_AppIcon, { name: "close" })
      ])), [
        [_directive_test, 'close-notification-panel-mobile']
      ])
    ])), [
      [_directive_test, 'toggle-notifications-panel']
    ]),
    _createVNode(MobileNotificationsTransition, null, {
      default: _withCtx(() => [
        (_unref(notificationsPanelActive))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(MainNotificationPanel, {
                onCloseNavigationPanel: _cache[0] || (_cache[0] = ($event: any) => (hideNotificationPanel(true))),
                notifications: _unref(notifications)
              }, null, 8, ["notifications"]),
              (_openBlock(), _createBlock(_Teleport, { to: "#modals" }))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2)), [
    [_directive_test, 'notifications-wrapper'],
    [_directive_clicked_outside, hideNotificationPanel]
  ])
}
}

})